<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap-reverse list-header">
      <div class="d-flex">
        <!-- 一覧のページング -->
        <!-- 設定(pagenate)が無い場合はページングしない -->
        <div v-if="filteredList.length > 0 && pagenate" class="pager">
          <b-pagination
            v-model="pagenate.currentPage"
            :total-rows="filteredList.length"
            :per-page="pagenate.perPage"
            :aria-controls="tableId"
            @change="changePage()"
            class="default-table"
          ></b-pagination>
        </div>

        <!-- 検索欄 -->
        <!-- 設定(textSearch)が無い場合は検索しない -->
        <div v-if="fullList.length > 0 && searchAvailable()">
          <b-button v-b-toggle="tableId + '-search'" :variant="buttonColor" @click="changeToggleStatus()">
            {{ searchButtonText }}
          </b-button>
        </div>
      </div>
      <slot></slot>
    </div>
    <div v-if="fullList.length > 0">
      <div>
        <SearchForm
          :id="tableId + '-search'"
          :search="tmpSearch"
          :fields="fields"
          :textPlaceholder="textPlaceholder"
          @updateSearch="updateSearch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SearchForm from '@/components/SearchForm.vue'

export default {
  name: 'ListHeader',

  components: {
    SearchForm
  },

  props: {
    tableId: String,
    filteredList: Array,
    textPlaceholder: {
      type: String,
      default: '検索ワード'
    },
    search: {
      type: Object,
      default() {
        return {
          text: '',
          select: {},
          date: {},
          boolean: {}
        }
      }
    },
    fullList: Array,
    fields: Array,
    pagenate: Object
  },

  computed: {
    buttonColor() {
      if (this.toggleStatus) {
        return 'outline-secondary'
      }
      return 'outline-info'
    },
    searchButtonText() {
      if (this.toggleStatus) {
        return '検索欄▲'
      }
      return '検索欄▼'
    }
  },

  data() {
    return {
      tmpSearch: this.search,
      toggleStatus: false
    }
  },

  methods: {
    updateSearch(e) {
      this.tmpSearch = e
      this.$nextTick().then((e) => {
        this.$emit('updateSearch', this.tmpSearch)
      })
    },
    changePage() {
      this.$emit('changePage', this.pagenate)
    },
    changeToggleStatus() {
      if (this.toggleStatus) {
        this.toggleStatus = false
      } else {
        this.toggleStatus = true
      }
    },
    searchAvailable(e) {
      // 1つでも検索を使用するならtrue
      return this.fields.some((item) => item.textSearch === true)
    }
  }
}
</script>

<style coped>
.pager {
  margin-right: 10px;
}

.list-header > div {
  margin-top: 5px;
}
</style>
